<template>
    <div class="main-screen-component">
        <div class="main-screen">
            <div class="overlay" :class="{ 'open': isSidebarMenuOpen }" @click="closeMenu">
                <ConversationSidebarComponent :modo-redaccion="modoRedaccion" @show-toast="showToast"
                    :isSidebarMenuOpen="isSidebarMenuOpen" :new_conversation_info="new_conversation_info"
                    :conversation_id="conversation_id" :email="email"
                    @conversation-selected="updateConversationSelected" :is_new_conversation="is_new_conversation"
                    :conversation_title="conversation_title" :subscription="subscription"
                    :userProfilePicture="profilePicture" :userName="name" :permissions="permissions" @logout="logout" />
            </div>

            <div class="chat-area">
                <HeaderMenuComponent :title="conversation_title || 'Nueva conversación'" :permissions="permissions"
                    :subscription="subscription" :isMobile="isMobile" @toggle-sidebar="toggleMenu" @logout="logout"
                    @show-toast="showToast" />

                <ChatComponent v-if="!modoRedaccion" @logout="logout" @show-toast="showToast"
                    @new-conversation-name="setNewConversationName" :email="email" :conversation_id="conversation_id"
                    :conversation_title="conversation_title" :is_new_conversation="is_new_conversation"
                    :prompt-suggestions="promptSuggestions" :profile-pic="profilePicture" :user-name="name"
                    :subscription="subscription" />
                <RedaccionToolComponent v-else @logout="logout" @show-toast="showToast"
                    @new-conversation-name="setNewConversationName" :email="email" :conversation_id="conversation_id"
                    :conversation_title="conversation_title" :is_new_conversation="is_new_conversation"
                    :profile-pic="profilePicture" :user-name="name" :selectedOption="menuSelectedOption" />
            </div>
        </div>
    </div>
</template>

<script>
import ChatComponent from './ChatComponent.vue';
import ConversationSidebarComponent from './ConversationSidebarComponent.vue';
import RedaccionToolComponent from './RedaccionToolComponent.vue';
import HeaderMenuComponent from './HeaderMenuComponent.vue';
import axios from 'axios';
import { COUNTRY } from '../utils/countryConfig';
axios.defaults.withCredentials = true;

export default {
    name: 'MainScreenComponent',
    components: {
        ConversationSidebarComponent,
        ChatComponent,
        RedaccionToolComponent,
        HeaderMenuComponent
    },
    props: {
        email: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        profilePicture: {
            type: String,
            required: false
        },
        subscription: {
            type: Object,
            required: false,
            default: null
        },
        modoRedaccion: {
            type: Boolean,
            required: false,
            default: false
        },
        permissions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            conversation_id: null,
            conversation_title: null,
            is_new_conversation: true,
            new_conversation_info: {
                conversation_title: null,
                conversation_id: null
            },
            promptSuggestions: [],
            isSidebarMenuOpen: false,
            menuSelectedOption: null,
            isMobile: false
        };
    },
    computed: {
        hasRedaccionPermission() {
            return this.permissions.includes('redaccion:data');
        }
    },
    methods: {
        updateConversationSelected(conversationId, conversationTitle, is_new, menuSelectedOption) {
            this.conversation_id = conversationId;
            this.conversation_title = conversationTitle;
            this.is_new_conversation = is_new;
            this.isSidebarMenuOpen = false;
            this.menuSelectedOption = menuSelectedOption;
        },
        setNewConversationName(conversationTitle, conversation_id) {
            this.conversation_id = conversation_id;
            this.conversation_title = conversationTitle;
            this.is_new_conversation = false;
            this.new_conversation_info = {
                conversation_title: conversationTitle,
                conversation_id: conversation_id
            };
        },
        logout() {
            this.$emit('logout');
        },
        async getPromptSuggestions() {
            axios.get(process.env.VUE_APP_BASE_URL + '/api/v2/prompt-suggestions/', {
                params: {
                    country: COUNTRY
                }
            })
                .then(response => {
                    this.promptSuggestions = response.data;
                })
                .catch(error => {
                    console.error('Error fetching prompt suggestions:', error);
                    this.showToast("¡Estamos con mucha demanda! al intentar obtener sugerencias de prompts.", "warning");
                });
        },
        closeMenu() {
            this.isSidebarMenuOpen = false;
        },
        toggleMenu() {
            this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
        },
        showToast(message, type) {
            this.$emit('show-toast', message, type);
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        }
    },
    async mounted() {
        await this.getPromptSuggestions();

        // Check if device is mobile
        this.checkMobile();

        // Add resize event listener
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        // Clean up event listener
        window.removeEventListener('resize', this.checkMobile);
    }
};
</script>

<style>
.main-screen-component {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100vh;
    width: 100%;
    overflow: hidden;
}

.main-screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-grow: 0;
}

.chat-area {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
    min-width: 0;
}

@media screen and (max-width: 768px) {
    .main-screen-component {
        height: 100dvh;
    }

    .main-screen {
        flex-direction: column;
        flex-grow: 1;
        position: relative;
    }

    .chat-area {
        width: 100%;
    }

    .overlay.open {
        position: fixed;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100vw;
        height: 100vh;
        height: 100dvh;
        z-index: 10;
        background: rgba(0, 0, 0, 0.75);
    }
}
</style>
